AUI().ready(

	/*
	This function gets loaded when all the HTML, not including the portlets, is
	loaded.
	*/

	function() {
	}
);

Liferay.Portlet.ready(

	/*
	This function gets loaded after each and every portlet on the page.

	portletId: the current portlet's id
	node: the Alloy Node object of the current portlet
	*/

	function(portletId, node) {
	}
);

Liferay.on(
	'allPortletsReady',
	/*
	This function gets loaded when everything, including the portlets, is on
	the page.
	*/

	function() {
	}

);

//SET CURSOR POSITION
function setCaretAtEnd(elem) {
    var elemLen = elem.value.length;
    // For IE Only
    if (document.selection) {
        // Set focus
        elem.focus();
        // Use IE Ranges
        var oSel = document.selection.createRange();
        // Reset position to 0 & then set at end
        oSel.moveStart('character', -elemLen);
        oSel.moveStart('character', elemLen);
        oSel.moveEnd('character', 0);
        oSel.select();
    }
    else if (elem.selectionStart || elem.selectionStart == '0') {
        // Firefox/Chrome
        elem.selectionStart = elemLen;
        elem.selectionEnd = elemLen;
        elem.focus();
    } 
}



$(document).ready(function() {
	
	$("input.datePicker").datepicker({
		"dateFormat":"dd.mm.yy"
	});
	
	$(".modalConfirm").click(function(event){

		event.preventDefault();
		
		var href = $(this).attr('href');
		var formId = $(this).attr('formId');
		var content = $(this).attr('content');
		var btnOkText = $(this).attr('btnOk');
		var btnCancelText = $(this).attr('btnCancel');
		var inverse = $(this).attr('inverse');

		var dialog = $("#dialog-confirm").dialog({
			autoOpen: false,
			width: 400,
			modal: true,
			resizable: false,
			open : function (){
				$(this).html(content);
			},
			buttons:  [ 
				{
					text: btnCancelText,
					"class": inverse ? 'btn btn-inverse' : 'btn btn-primary',
					click: function() {
						$(this).dialog("close");
					}
				},
				{
					text: btnOkText,
					"class": inverse ? 'btn btn-primary' : 'btn btn-inverse',
					click: function() {
						if(formId != null){
							$('#'+formId).first().submit();
						} else if (href != null){
							window.location.href = href;
						}
					}
				
				}
			]
		});
		
		dialog.dialog('open');
	});
	
	$( ".remitPhoneInputAddPlus" ).click(function() {

		var input = $( ".remitPhoneInputAddPlus" );
		 if(input.val() == ""){
			 input.focus();
			 input.val("+");
			 setCaretAtEnd(input.get(0));
		}
	});
	
	$( ".remitFaxInputAddPlus" ).click(function() {
		var input = $( ".remitFaxInputAddPlus" );
		 if(input.val() == ""){
			 input.focus();
			 input.val("+");
			 setCaretAtEnd(input.get(0));
		}
	});
});